/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_SubtitleInputs */

const en_landing_how_subtitle = /** @type {(inputs: Landing_How_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No guesswork. No generic templates. AI that actually understands the job you're applying for.`)
};

const de_landing_how_subtitle = /** @type {(inputs: Landing_How_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Raten. Keine generischen Vorlagen. KI, die die Stelle wirklich versteht.`)
};

const fr_landing_how_subtitle = /** @type {(inputs: Landing_How_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de devinettes. Pas de modèles génériques. Une IA qui comprend vraiment le poste pour lequel tu postules.`)
};

const es_landing_how_subtitle = /** @type {(inputs: Landing_How_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conjeturas. Sin plantillas genéricas. IA que realmente entiende el puesto al que te presentas.`)
};

const it_landing_how_subtitle = /** @type {(inputs: Landing_How_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niente congetture. Niente modelli generici. Un'AI che capisce davvero il lavoro per cui ti stai candidando.`)
};

const nl_landing_how_subtitle = /** @type {(inputs: Landing_How_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen giswerk. Geen generieke sjablonen. AI die de baan waarvoor je solliciteert echt begrijpt.`)
};

const pl_landing_how_subtitle = /** @type {(inputs: Landing_How_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żadnego zgadywania. Żadnych ogólnych szablonów. AI, które naprawdę rozumie ofertę, na którą aplikujesz.`)
};

const fi_landing_how_subtitle = /** @type {(inputs: Landing_How_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei arvailua. Ei yleismalleja. Tekoäly, joka oikeasti ymmärtää haettavan työpaikan.`)
};

const da_landing_how_subtitle = /** @type {(inputs: Landing_How_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intet gætværk. Ingen generiske skabeloner. AI der faktisk forstår det job, du søger.`)
};

const sv_landing_how_subtitle = /** @type {(inputs: Landing_How_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen gissning. Inga generiska mallar. AI som faktiskt förstår jobbet du söker.`)
};

/**
* | output |
* | --- |
* | "No guesswork. No generic templates. AI that actually understands the job you're applying for." |
*
* @param {Landing_How_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_how_subtitle = /** @type {((inputs?: Landing_How_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_how_subtitle(inputs)
	if (locale === "fr") return fr_landing_how_subtitle(inputs)
	if (locale === "es") return es_landing_how_subtitle(inputs)
	if (locale === "it") return it_landing_how_subtitle(inputs)
	if (locale === "nl") return nl_landing_how_subtitle(inputs)
	if (locale === "pl") return pl_landing_how_subtitle(inputs)
	if (locale === "fi") return fi_landing_how_subtitle(inputs)
	if (locale === "da") return da_landing_how_subtitle(inputs)
	if (locale === "sv") return sv_landing_how_subtitle(inputs)
	return en_landing_how_subtitle(inputs)
});